// extracted by mini-css-extract-plugin
export default {"box":"Annotation_box__10C2-","flareAnimation":"Annotation_flareAnimation__dYOsF","shine":"Annotation_shine__5StVd"};